export enum EContractActions {
  ADMIN_DELETE_CONTRACT = "ADMIN_DELETE_CONTRACT",
  CUSTOMER_FUND = "CUSTOMER_FUND",
  PROVIDER_CHECK_ESCALATION = "PROVIDER_CHECK_ESCALATION",
  CUSTOMER_CONFIRM_DELIVERY = "CUSTOMER_CONFIRM_DELIVERY",
  CUSTOMER_DENY_DELIVERY = "CUSTOMER_DENY_DELIVERY",
  CUSTOMER_ACCEPT_ITEM = "CUSTOMER_ACCEPT_ITEM",
  CUSTOMER_REJECT_ITEM = "CUSTOMER_REJECT_ITEM",
  ADMIN_CONFIRM_DELIVERY = "ADMIN_CONFIRM_DELIVERY",
  ADMIN_REFUND_CUSTOMER = "ADMIN_REFUND_CUSTOMER",
  ADMIN_RELEASE_FUND_TO_SELLER = "ADMIN_RELEASE_FUND_TO_SELLER",
  CUSTOMER_CHECK_ESCALATION = "CUSTOMER_CHECK_ESCALATION",
  PROVIDER_ESCALATE_DELIVERY = "PROVIDER_ESCALATE_DELIVERY",
  PROVIDER_ESCALATE_ITEM = "PROVIDER_ESCALATE_ITEM",
}
